angular.module(module.exports = 'ttb.issue.workLogDetails.workLogEditor.component', [
    require('./edit-form')
])
    .component('workLogEditor', {
        template: `
            <div class="work-log-editor" stop-enter-propagation>
                <div class="modal-header">
                    <h3 class="modal-title">{{'WorkLog_Title' | translate}}</h3>
                    <button type="button" class="close" ng-click="$ctrl.close()"><i class="fa fa-times"></i></button>
                </div>
                <div class="modal-body">
                    <edit-form
                            creation-mode="$ctrl.resolve.creationMode"
                            activity-log-id="$ctrl.resolve.activityLogId"
                            issue-id="$ctrl.resolve.issueId"
                            team-id="$ctrl.resolve.teamId"
                            is-project-iteration-based="$ctrl.resolve.isProjectIterationBased"
                            on-saved="$ctrl.save($event.workLog)"
                            on-canceled="$ctrl.close()"
                        >
                    </edit-form>
                </div>
            </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: WorkLogEditor
    });

function WorkLogEditor() {

    this.$onInit = () => {
        if (DEBUG) {
            console.log(this);
        }
    }

    this.save = (workLog) => {
        this.close({ $value: workLog });
    };
}
WorkLogEditor.$inject = [];


// WEBPACK FOOTER //
// ./components/work-log-editor/work-log-editor.component.js